import { Box, CardContent, Typography } from '@mui/material';
import Container from 'components/Container';
import Main from 'layouts/Main';
import AppCard from 'components/AppCard';
import { Form } from './components';

const PasswordResetCover = () => {
    return (
        <Main>
            <Box
                sx={{
                    width: 1,
                    height: 1,
                    overflow: 'hidden',
                    background:
                        'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
                    minHeight: '100vh',
                    py: 6,
                }}
            >
                <Container maxWidth="sm">
                    <AppCard>
                        <CardContent sx={{ p: 4 }}>
                            <Form />
                        </CardContent>
                    </AppCard>
                </Container>
            </Box>
        </Main>
    );
};

export default PasswordResetCover;
